const StockOverlay = ({ stock, compact = false }) => {
  if (Number(stock) > 0) return null;

  return (
    <span
      className={`pointer-events-none absolute inset-x-0 top-1/2 z-20 -translate-y-1/2 bg-red-600 text-center font-bold uppercase tracking-wide text-white shadow ${
        compact ? 'py-1 text-[9px]' : 'py-2 text-xs'
      }`}
      aria-label="Coming soon"
    >
      Coming Soon
    </span>
  );
};

export default StockOverlay;
